import Forward from '@sats-group/icons/16/forward';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';
import VisuallyButton from '@sats-group/ui-lib/react/visually-button';
import cn from 'classnames';
import React from 'react';
import { MediaType } from '~/shared/media-type-helper';
import BackgroundImage from '../background-image/background-image';
import BackgroundVideo from '../background-video/background-video';
import type { ArticleCard as Props } from './article-card.types';

const ArticleCard: React.FunctionComponent<Props> = ({
  href,
  linkText,
  media,
  mediaRatioLock,
  tags = [],
  tall,
  text,
  title,
  type,
}) => (
  <a
    className={cn('article-card', {
      'article-card--tall': tall,
    })}
    href={href}
  >
    <div
      className={cn('article-card__inner', {
        [`article-card__inner--type-${type}`]: type,
      })}
    >
      <div className="article-card__media">
        {media.type === MediaType.Image ? (
          <BackgroundImage {...media.props} />
        ) : null}
        {media.type === MediaType.RawSvg ? (
          <div
            aria-hidden
            role="img"
            className="article-card__raw-svg"
            dangerouslySetInnerHTML={{ __html: media.props }}
          />
        ) : null}
        {media.type === MediaType.Video ? (
          <BackgroundVideo {...media.props} />
        ) : null}
        <div
          className={cn('article-card__media-minimum', {
            [`article-card__media-minimum--ratio-lock-${mediaRatioLock}`]:
              mediaRatioLock,
          })}
        />
      </div>
      <div className="article-card__content">
        {tags.length ? (
          <div className="article-card__tags">
            {tags.map(tag => (
              <Tag {...tag} key={tag.key} variant={Tag.variants.secondary} />
            ))}
          </div>
        ) : null}
        <Text theme={Text.themes.emphasis} size={Text.sizes.headline3} tight>
          {title}
        </Text>
        {text ? <Text tight>{text}</Text> : null}
      </div>
    </div>

    <div className="article-card__overlay">
      <Text theme={Text.themes.emphasis}>{linkText}</Text>
      <VisuallyButton
        elementName="div"
        iconOnly
        leadingIcon={<Forward />}
        role="img"
        text={linkText}
        variant={VisuallyButton.variants.secondaryWhite}
      />
    </div>
  </a>
);

export default ArticleCard;
